import localforage from 'localforage'
import Api from '../core/Api'
import Offline from './Offline'

class Piece {
    static serialize(data){
        let payload = {};

        payload.id = data.id;
        payload.idFibsdd = data.fiche;
        payload.designation = data.designation;
        payload.changed = data.etat;
        payload.quantity = data.qte;
        payload.price = data.prix;

        return payload;
    }

    static async addOnline(id) {
        let api = await Api.init();
        let piece = await Piece.getPiece(id);
        let payload = Piece.serialize(piece);
        let idFiche = payload.idFibsdd;

        delete payload.idFibsdd;
        delete payload.id;

        try {
            await api.post('/piece/' + idFiche, payload);
            await Offline.deleteAction(id, 'Piece');
            return true;

        } catch (e) {}
    }

    static async removeOnline(id){
        let api = await Api.init();

        try {
            await api.delete('/piece/' + id)
        } catch(e) {}

        await Offline.deleteAction(id, 'Piece');

        return true;
    }

    static async addOffline(data) {

        try {
            let pieces = await Piece.getList();
            pieces.push(data);
            await localforage.setItem('listPieces', JSON.stringify(pieces));
            await Offline.saveAction({action: 'add', type: 'Piece', id: data.id});

            return true;
        } catch (e) {
            return false;
        }

    }

    static async remove(id) {
        let pieces = await Piece.getList();

        try {
            let newList = _.remove(pieces, p => p.id !== id);
            await localforage.setItem('listPieces', JSON.stringify(newList));

            if(!_.includes(id, 'P-')){
                Offline.saveAction({
                    type: "Piece",
                    action: "delete",
                    id: id
                })
            } else {
                Offline.deleteAction(id, 'Piece')
            }
        } catch (err) {
            return false
        }

        return true
    }

    static async getListForFiche(idFiche) {
        let pieces = await Piece.getList();

        return pieces.filter( p => p.fiche == idFiche );
    }

    static async getPiece(id) {
        let list = await Piece.getList();

        return list.find( p => p.id === id );
    }

    static async getList() {
        return JSON.parse( await localforage.getItem('listPieces'));
    }
}

export default Piece



// WEBPACK FOOTER //
// ./src/js/models/Piece.js